var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-ip',{staticStyle:{"width":"160px"},attrs:{"value":"192.168.168.168"},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }